/**
 * scroll-video.js — HYBRID VERSION (VIDEO + IMAGE SEQUENCE)
 */

document.addEventListener('DOMContentLoaded', () => {

  if (!window.gsap || !window.ScrollTrigger) return;

  gsap.registerPlugin(ScrollTrigger);

  const containers = document.querySelectorAll('[data-scroll-video]');

  containers.forEach((container) => {

    const sticky      = container.querySelector('.scroll-video__sticky');
    const video       = container.querySelector('.scroll-video__video');
    const image       = container.querySelector('.scroll-sequence');
    const annotations = [...container.querySelectorAll('.scroll-video__annotation')];

    const isMobile    = ScrollTrigger.isTouch === 1;
    const useSequence = container.dataset.useSequence === "true";

    const scrollHeight = parseInt(container.dataset.scrollHeight, 10) || 300;
    const pinDuration  = window.innerHeight * (scrollHeight / 100);

    const format = container.dataset.format || "png";

    if (!sticky) return;

    // =========================
    // MOBILE (fallback simple)
    // =========================
    if (isMobile) {

      // 👉 si image sequence → on garde GSAP
      if (useSequence && image) {
        // on laisse continuer (pas de return)
      } 

      // 👉 si vidéo → fallback autoplay
      else if (video) {
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.autoplay = true;
        video.play().catch(() => {});
        return;
      }
    }

    // =========================
    // 🧠 MODE IMAGE SEQUENCE
    // =========================
    if (useSequence && image) {

      const frameCount = parseInt(container.dataset.frames, 10) || 96;
      const base       = container.dataset.base;

      let currentFrame = 0;

      const images = [];

      // preload léger (évite freeze)
      const preloadCount = Math.min(frameCount, 20);

      for (let i = 1; i <= preloadCount; i++) {
        const img = new Image();
        // img.src = `${base}${String(i).padStart(3, '0')}.png`;
        img.src = `${base}${String(i).padStart(3, '0')}.${format}`;
        images.push(img);
      }
      if (images[0]) console.log(images[0].src);

      ScrollTrigger.create({
        trigger: container,
        start: 'top top',
        end: `+=${pinDuration}`,
        pin: sticky,
        scrub: 1,
        anticipatePin: 1,
        // markers: true,

        onUpdate: (self) => {

          const frame = Math.floor(self.progress * (frameCount - 1));

          if (frame !== currentFrame) {
            currentFrame = frame;

            // lazy load dynamique
            if (!images[frame]) {
              const img = new Image();
              // img.src = `${base}${String(frame + 1).padStart(3, '0')}.png`;
              img.src = `${base}${String(frame + 1).padStart(3, '0')}.${format}`;
              images[frame] = img;
            }

            image.src = images[frame].src;
          }

          // annotations
          annotations.forEach((annotation) => {
            const threshold = parseFloat(annotation.dataset.trigger) / 100;
            annotation.classList.toggle('is-visible', self.progress >= threshold);
          });
        }
      });

      return; // ⛔ stop ici → pas de vidéo
    }

    // =========================
    // 🎬 MODE VIDEO (ton système actuel amélioré)
    // =========================
    if (!video) return;

    video.pause();
    video.currentTime = 0;

    let targetTime = 0;
    let currentTime = 0;

    const lerp = (a, b, n) => a + (b - a) * n;

    const update = () => {
      currentTime = lerp(currentTime, targetTime, 0.1);
      video.currentTime = currentTime;
      requestAnimationFrame(update);
    };

    requestAnimationFrame(update);

    const init = () => {

      if (!video.duration || isNaN(video.duration)) {
        video.addEventListener('canplay', init, { once: true });
        return;
      }

      ScrollTrigger.create({
        trigger: container,
        start: 'top top',
        end: `+=${pinDuration}`,
        pin: sticky,
        scrub: 0.8,
        anticipatePin: 1,
        // markers: true,

        onUpdate: (self) => {

          targetTime = self.progress * video.duration;

          annotations.forEach((annotation) => {
            const threshold = parseFloat(annotation.dataset.trigger) / 100;
            annotation.classList.toggle('is-visible', self.progress >= threshold);
          });
        }
      });
    };

    if (video.readyState >= 1) {
      init();
    } else {
      video.addEventListener('loadedmetadata', init, { once: true });
    }

  });

});
























// /**
//  * scroll-video.js — FINAL SMOOTH FIX
//  */

// document.addEventListener('DOMContentLoaded', () => {

//   if (!window.gsap || !window.ScrollTrigger) return;

//   gsap.registerPlugin(ScrollTrigger);

//   const containers = document.querySelectorAll('[data-scroll-video]');

//   containers.forEach((container) => {

//     const sticky      = container.querySelector('.scroll-video__sticky');
//     const video       = container.querySelector('.scroll-video__video');
//     const annotations = [...container.querySelectorAll('.scroll-video__annotation')];
//     const isMobile    = ScrollTrigger.isTouch === 1;

//     if (!sticky || !video) return;

//     if (isMobile) {
//       video.muted = true;
//       video.loop = true;
//       video.playsInline = true;
//       video.autoplay = true;
//       video.play().catch(() => {});
//       return;
//     }

//     video.pause();
//     video.currentTime = 0;

//     const scrollHeight = parseInt(container.dataset.scrollHeight, 10) || 300;
//     const pinDuration  = window.innerHeight * (scrollHeight / 100);

//     let targetTime = 0;
//     let currentTime = 0;

//     // 🔥 simple lerp (rien d’autre)
//     const lerp = (a, b, n) => a + (b - a) * n;

//     const update = () => {
//       currentTime = lerp(currentTime, targetTime, 0.1);
//       video.currentTime = currentTime;
//       requestAnimationFrame(update);
//     };

//     requestAnimationFrame(update);

//     const init = () => {

//       if (!video.duration || isNaN(video.duration)) {
//         video.addEventListener('canplay', init, { once: true });
//         return;
//       }

//       ScrollTrigger.create({
//         trigger: container,
//         start: 'top top',
//         end: `+=${pinDuration}`,
//         pin: sticky,
//         scrub: 0.8, // 👈 plus faible !
//         anticipatePin: 1,
//         markers: true,

//         onUpdate: (self) => {
//           targetTime = self.progress * video.duration;

//           annotations.forEach((annotation) => {
//             const threshold = parseFloat(annotation.dataset.trigger) / 100;
//             annotation.classList.toggle('is-visible', self.progress >= threshold);
//           });
//         }
//       });
//     };

//     if (video.readyState >= 1) {
//       init();
//     } else {
//       video.addEventListener('loadedmetadata', init, { once: true });
//     }

//   });

// });
